module.exports = __webpack_public_path__ + "static/media/spinner.0c6f34a3.gif";